module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM",
      "placeholder": "Search by Month",
      "type": "month"
    },
    on: {
      "change": _vm.changeSearchMonth
    },
    model: {
      value: (_vm.filters.searchMonth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchMonth", $$v)
      },
      expression: "filters.searchMonth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByDaily
    }
  }, [_vm._v("Build Storage Fee for Today")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.testGenStorageFeeByMonthly
    }
  }, [_vm._v("Build Storage Fee for Month")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByDailyWin
    }
  }, [_vm._v("Rebuild Storage Fee for Daily")]) : _vm._e(), _vm._v(" "), (_vm.user.userNo == 'user-9aa177023c4340609ce337d618d0bd99' || _vm.user.userNo == 'user-bcfde657d5684dd694d89ae424f11530') ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isEnable,
      "type": "primary"
    },
    on: {
      "click": _vm.showRebuildStorageFeeByMonthWin
    }
  }, [_vm._v("Rebuild Fee for Month")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                        Detail\n                    ")]), _vm._v(" "), (scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showPaymentList(scope.row)
            }
          }
        }, [_vm._v("Payment")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "90%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 4)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "descs",
      "label": "Desc"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false;
        _vm.filters.conditionSearch = ''
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [(!_vm.isPaymentPending) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total payment",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Daily for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildDailyModel",
    attrs: {
      "model": _vm.rebuildDailyModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Date",
      "prop": "dates"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Rebuild dates, example: 2023-09-01,2023-09-02,2023-09-10 etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildDailyModel.dates),
      callback: function($$v) {
        _vm.$set(_vm.rebuildDailyModel, "dates", $$v)
      },
      expression: "rebuildDailyModel.dates"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildVisible = false;
        _vm.rebuildDailyModel.dates = '';
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByDaily.apply(null, arguments)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rebuild Month for Storage Fee",
      "width": "80%",
      "visible": _vm.requestRebuildMonthVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestRebuildMonthVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "rebuildMonthModel",
    attrs: {
      "model": _vm.rebuildMonthModel,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rebuild Month",
      "prop": "month"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Monthly Fee Report Rebuild, example: 2023-09  only one, dont set multiple month`s.",
      "clearable": ""
    },
    model: {
      value: (_vm.rebuildMonthModel.month),
      callback: function($$v) {
        _vm.$set(_vm.rebuildMonthModel, "month", $$v)
      },
      expression: "rebuildMonthModel.month"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestRebuildMonthVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isEnable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rebuildStorageFeeByMonth.apply(null, arguments)
      }
    }
  }, [_vm._v("Rebuild")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-661889c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/payments.vue
// module id = 833
// module chunks = 1